(function () {
  const globalKey = '__experienceMarketplaceWidget';

  function injectStylesheet(href) {
    if (document.querySelector(`link[data-experience-widget="styles"][href="${href}"]`)) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.experienceWidget = 'styles';
    document.head.appendChild(link);
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[data-experience-widget="bundle"][src="${src}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.dataset.experienceWidget = 'bundle';
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  function createContainerFromHtml(html) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html.trim();
    return wrapper.firstElementChild;
  }

  async function loadWidget(venueId, options = {}) {
    if (!venueId) {
      throw new Error('venueId is required to initialize the Experience Marketplace widget.');
    }

    if (window[globalKey]?.initialized) {
      console.warn('[ExperienceWidget] Widget already initialized. Skipping duplicate load.');
      return;
    }

    const baseUrl = options.baseUrl || (typeof EAGLEEYE_EXPERIENCE_WIDGET_BASE_URL !== 'undefined'
      ? EAGLEEYE_EXPERIENCE_WIDGET_BASE_URL
      : 'http://localhost:3300');

    const apiUrl = options.apiUrl || (typeof EAGLEEYE_API_BASE_URL !== 'undefined'
      ? EAGLEEYE_API_BASE_URL
      : 'https://localhost:2288');

    const paymentServiceUrl = options.paymentServiceUrl || (typeof EAGLEEYE_PAYMENT_SERVICE_BASE_URL !== 'undefined'
      ? EAGLEEYE_PAYMENT_SERVICE_BASE_URL
      : 'https://localhost:7001');

    window[globalKey] = {
      initialized: false,
      config: { venueId, baseUrl, apiUrl, paymentServiceUrl, branding: options.branding || null }
    };

    injectStylesheet(`${baseUrl}/public/css/main.css`);

    const response = await fetch(`${baseUrl}/widget?venueId=${encodeURIComponent(venueId)}`);
    if (!response.ok) {
      throw new Error(`Failed to load widget markup (status ${response.status})`);
    }
    const html = await response.text();
    const container = createContainerFromHtml(html);

    const targetSelector = options.targetSelector;
    if (targetSelector) {
      const host = document.querySelector(targetSelector);
      if (!host) {
        throw new Error(`Target element not found for selector: ${targetSelector}`);
      }
      host.appendChild(container);
    } else {
      document.body.appendChild(container);
    }

    await loadScript(`${baseUrl}/public/js/main.bundle.js`);

    if (typeof window.initializeExperienceMarketplaceWidget === 'function') {
      window.initializeExperienceMarketplaceWidget({
        venueId,
        apiUrl,
        paymentServiceUrl,
        baseUrl,
        branding: window[globalKey].config.branding
      });
      window[globalKey].initialized = true;
    } else {
      console.error('[ExperienceWidget] initializeExperienceMarketplaceWidget was not found on window.');
    }
  }

  window.loadExperienceMarketplaceWidget = loadWidget;
})();



